'use strict';

angular.module('app').component('app', {
    templateUrl: 'app/main/main.html'
});